import moment from 'moment'
import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const PackageResultBlock = ({ filteredPackages, packageResult }) => {
    const culture = useSelector((state) => state.culture.currentCulture);
    const lang = useSelector((state) => state.culture.language);

    return (
        filteredPackages.map((pkg, index) => {
            const { PackageKey, PackageName, BasicInfo, Criteria, Features, FareDetails } = pkg;
            const { PackageImageUrls, Location } = BasicInfo || {};
            const { ValidFrom, ValidTo } = Criteria || {};
            const { Includes = [], HighLights = [] } = Features || {};

            return (
                <div className="packresultpanel" key={PackageKey || index}>
                    <div className="result_panel_col_l">
                        <div className="spackrsltBox">
                            <div className="spackrslt_pic">
                                {PackageImageUrls?.[0] && (
                                    <img
                                        src={PackageImageUrls[0]}
                                        alt={PackageName}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "images/no_image_package.jpg";
                                        }}
                                    />
                                )}
                            </div>
                            <div className="spackrslt_Dtls">
                                <h2>{PackageName}</h2>
                                <p>{Location}</p>
                                <p>{lang.validity ?? 'Validity'}: {moment(ValidFrom, "DD/MM/YYYY").format("DD MMM YYYY")} - {moment(ValidTo, "DD/MM/YYYY").format("DD MMM YYYY")}</p>
                                <ul className="d-flex align-items-center spackLists">
                                    {Includes.map((item) => (
                                        <li key={item} className="d-flex align-items-center">
                                            <i className={`spack_${item.toLowerCase()}`} />
                                            <span>{lang[item.toLowerCase()]}</span>
                                        </li>
                                    ))}
                                </ul>
                                <p>{HighLights.join(", ")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="result_panel_col_R d-flex flex-column justify-content-center">
                        <div className="resultfareDetails">
                            <div className="htlrsltpriceL">
                                {/* <div className="resultFare strikedfare">
                                    <span>{FareDetails?.Currency} </span><span>80.000</span>
                                </div> */}
                                <div className="resultFare">
                                    <span>{FareDetails?.Currency} </span><span>{FareDetails?.Total}</span>
                                </div>
                            </div>
                            <div className="htlrsltpriceR">
                                <div className="FlgtSelect">
                                    <Link
                                        to={`${process.env.REACT_APP_BASE_URL}${culture}/package-details?packagekey=${PackageKey}`}
                                        className="theme_btnStyle resltselectbtn"
                                    >
                                        {lang.select}
                                    </Link>
                                </div>
                                <div className="w-100 d-flex flex-wrap">
                                    <div className="ResultSelectLdr loader-sm mt-2 w-100 d-none">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }))
}


export default PackageResultBlock